import { defineModule } from '@portal/kernel';

/** Partners: Network/MCN and content distribution, their contracts (docs/design/P5_PARTNERS.md). */
export const manifest = defineModule({
  key: 'partners',
  version: '0.1.0',
  kind: 'business',
  coreVersion: '^0.1.0',
  name: { vi: 'Đối tác', en: 'Partners' },
  description: {
    vi: 'Đối tác Network/MCN và phân phối nội dung, Network, hợp đồng và phụ lục, bộ nội dung được cấp phép.',
    en: 'Network/MCN and content distribution partners, networks, contracts and addenda, licensed titles.',
  },
  dependsOn: [
    'core-system',
    'core-audit',
    'core-identity',
    'core-access',
    'core-files',
    'core-notification',
  ],
  database: { schema: 'partners' },
  permissions: [
    {
      key: 'partners.partner.view',
      name: { vi: 'Xem đối tác và Network', en: 'View partners and networks' },
    },
    {
      key: 'partners.partner.manage',
      name: {
        vi: 'Quản lý đối tác, Network và tỷ lệ mặc định',
        en: 'Manage partners, networks and default rates',
      },
    },
    {
      key: 'partners.contract.view',
      name: { vi: 'Xem hợp đồng, file scan và tỷ lệ', en: 'View contracts, scans and rates' },
    },
    {
      key: 'partners.contract.manage',
      name: { vi: 'Quản lý hợp đồng, phụ lục và file', en: 'Manage contracts, addenda and files' },
    },
  ],
  navigation: [
    {
      id: 'partners',
      label: { vi: 'Đối tác', en: 'Partners' },
      icon: 'handshake',
      order: 110,
      children: [
        {
          id: 'partners.list',
          label: { vi: 'Đối tác', en: 'Partners' },
          icon: 'building',
          path: '/partners',
          permission: 'partners.partner.view',
          order: 1,
        },
        {
          id: 'partners.contracts',
          label: { vi: 'Hợp đồng', en: 'Contracts' },
          icon: 'file-text',
          path: '/partners/contracts',
          permission: 'partners.contract.view',
          order: 2,
        },
        {
          id: 'partners.titles',
          label: { vi: 'Bộ nội dung', en: 'Titles' },
          icon: 'clapperboard',
          path: '/partners/titles',
          permission: 'partners.partner.view',
          order: 3,
        },
      ],
    },
  ],
  roleTemplates: [
    {
      key: 'manager',
      name: { vi: 'Quản lý đối tác', en: 'Partner manager' },
      description: { vi: 'Quản lý đối tác, Network, tỷ lệ mặc định, hợp đồng và file scan.' },
      grants: [
        { permission: 'partners.partner.view' },
        { permission: 'partners.partner.manage' },
        { permission: 'partners.contract.view' },
        { permission: 'partners.contract.manage' },
      ],
    },
    {
      key: 'contract-viewer',
      name: { vi: 'Xem hợp đồng đối tác', en: 'Partner contract viewer' },
      description: { vi: 'Xem đối tác, hợp đồng, file scan và tỷ lệ (ban giám đốc).' },
      grants: [{ permission: 'partners.partner.view' }, { permission: 'partners.contract.view' }],
    },
  ],
  widgets: [
    {
      key: 'partners.expiring',
      title: { vi: 'Hợp đồng sắp hết hạn', en: 'Contracts expiring soon' },
      permission: 'partners.contract.view',
      order: 50,
    },
  ],
  notifications: [
    {
      key: 'partners.contract-expiring',
      name: { vi: 'Hợp đồng đối tác sắp hết hạn', en: 'Partner contract expiring' },
      description: { vi: 'Còn 30 ngày, 7 ngày và ngày hết hạn.' },
      defaultChannels: ['in_app', 'email'],
    },
  ],
});
